//#region src/schema/localization/locales/zh-cn.ts
var e = {
	schema: {
		variants: "变体",
		discriminatorValue: "鉴别器值",
		noAllowedValues: "没有值满足此枚举约束。",
		example: "示例",
		examples: "示例",
		default: "默认值",
		schema: "架构",
		emptyObject: "空对象",
		showAdditionalProperties: "显示附加属性",
		showOneMoreProperty: "再显示 1 个属性",
		showMoreProperties: "再显示 {count} 个属性",
		forName: "对于 {name}",
		showSchemaDetails: "显示架构详情",
		oneOf: "其中一个",
		anyOf: "任意一个",
		allOf: "全部",
		not: "非",
		unknownType: "未知类型",
		propertyCount: "属性：{count}",
		headerCount: "标头：{count}",
		recursiveReference: "递归引用 {name}",
		recursive: "递归",
		additionalProperties: "附加属性",
		const: "常量",
		deprecated: "已弃用",
		discriminator: "鉴别器",
		enum: "枚举",
		format: "格式",
		greaterThan: "大于",
		keys: "键",
		lessThan: "小于",
		max: "最大值",
		min: "最小值",
		maxLength: "最大长度",
		minLength: "最小长度",
		multipleOf: "倍数",
		nullable: "可为 null",
		propertyNames: "属性名称",
		pattern: "模式",
		copyPattern: "复制模式",
		readOnly: "只读",
		required: "必填",
		hideValues: "隐藏值",
		showAllValues: "显示所有值",
		type: "类型",
		unique: "唯一",
		values: "值",
		writeOnly: "只写",
		typeInteger: "整数。",
		formatInt32: "有符号 32 位整数（常用整数类型）。",
		formatInt64: "有符号 64 位整数（long 类型）。",
		formatDate: "RFC 3339 第 5.6 节定义的 full-date 表示法，例如 2017-07-21",
		formatDateTime: "RFC 3339 第 5.6 节定义的 date-time 表示法，例如 2017-07-21T17:32:28Z",
		formatPassword: "提示界面遮蔽输入内容",
		formatBase64: "base64 编码的字符，例如 U3dhZ2dlciByb2Nrcw==",
		formatBinary: "二进制数据，用于描述文件"
	},
	common: {
		copyDefault: "复制默认值",
		copyExample: "复制示例值"
	},
	actions: { copyLinkTo: "复制指向 {name} 的链接" }
};
//#endregion
export { e as zhCn };

//# sourceMappingURL=zh-cn.js.map